import './GuardianOfZone.css';

export default function ConcienciaGuardian() {
  return (
    <svg className="guardian-svg guardian-conciencia" viewBox="0 0 100 150" role="img">
      <title>Conciencia — El Tecno-Mago, de pie con un núcleo de luz entre las manos</title>
      <path d="M50 8 C40 8 34 18 35 30 C36 37 40 41 50 41 C60 41 64 37 65 30 C66 18 60 8 50 8 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.4" opacity="0.92" />
      <ellipse cx="50" cy="24" rx="7" ry="8" className="g-cutout" />
      <ellipse cx="46.5" cy="23.5" rx="1.6" ry="2" className="g-fill-core" />
      <ellipse cx="53.5" cy="23.5" rx="1.6" ry="2" className="g-fill-core" />
      <path d="M47 28.5 Q50 30.3 53 28.5" fill="none" className="g-stroke-core" strokeWidth="1" strokeLinecap="round" opacity="0.85" />
      <path d="M38 38 C22 46 16 70 15 100 C14 120 15 135 18 146 L82 146 C85 135 86 120 85 100 C84 70 78 46 62 38 C58 42 42 42 38 38 Z" className="g-fill-a g-stroke-bg" strokeWidth="1.6" opacity="0.85" />
      <path d="M38 51 L34 140" fill="none" className="g-stroke-bg" strokeWidth="1" opacity="0.5" />
      <path d="M62 51 L66 140" fill="none" className="g-stroke-bg" strokeWidth="1" opacity="0.5" />
      <path d="M50 47 L48 142" fill="none" className="g-stroke-bg" strokeWidth="1" opacity="0.4" />
      <path d="M38 42 C25 47 18 60 21 73 C23 80 29 84 37 82" fill="none" className="g-stroke-a" strokeWidth="5" strokeLinecap="round" opacity="0.88" />
      <path d="M62 42 C75 47 82 60 79 73 C77 80 71 84 63 82" fill="none" className="g-stroke-a" strokeWidth="5" strokeLinecap="round" opacity="0.88" />
      <circle cx="37" cy="82" r="3.8" className="g-fill-a g-stroke-bg" strokeWidth="1.1" />
      <circle cx="63" cy="82" r="3.8" className="g-fill-a g-stroke-bg" strokeWidth="1.1" />
      <circle cx="50" cy="82" r="11" className="g-fill-a" opacity="0.15" />
      <circle cx="50" cy="82" r="6.5" className="g-fill-core g-pulse" />
    </svg>
  );
}